import { client } from "./client";
import interceptors from "./interceptors";
// import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataProduct(params) {
    return client.get("tunnel/api/pos/product/data", {
        params: params
    });
}

function getDetailProduct(params) {
    return client.get("tunnel/api/pos/product/detail", {
        params: params,
    });
}

function getDataCategory() {
    return client.get("tunnel/api/pos/product/category");
}

export default {
    getDataProduct,
    getDetailProduct,
    getDataCategory
};